import { message as $message } from 'antd';
import axios from 'axios';
import { baseReq } from 'src/interface/base';
import store from 'src/stores';
import { getGlobalNavigate } from 'src/utils/navigate';
import { authServiceApp, mainApp } from './constants/serviceModule';

export type Response<T = any> = {
  rsCode: number;
  success: boolean;
  rsMessages: string;
  rsData: T;
};

export type ApiResponse<T = any> = Promise<Response<T>>;

// 从环境变量获取API基础URL，如果没有则使用默认值
export const baseURL = process.env.REACT_APP_API_BASE_URL || 'https://admin.darjawg.com/';
// if(Platform.OS === 'android') {
//   baseURL = 'https://www.91708.club';
// }

const instance = axios.create({
  // baseURL: '/api',
  // baseURL: baseURL,
  // baseURL: 'http://192.168.50.189:8081/api',
  timeout: 0,
  withCredentials: true // 允许携带 Cookie
});

//请求拦截处理
instance.interceptors.request.use(
  async function (config) {
    const user = await store.getState().user;
    const tagsView = await store.getState().tagsView;
    const menusState = await store.getState().menus;
    if (user) {
      config.headers['chyjrtgn-app1'] = `${user.chyjrtgnApp1}`;
      config.headers['cachekey-app1'] = `${user.cachekeyApp1}`;
      config.headers['platformsessionId'] = `${user.platformsessionId}`;
      config.headers['api'] = `${user.api}`;
      config.headers['uid'] = `${user.uid}`;
      // 直接以「當前頁面 path」反查 menuId，避免依賴 redux activeMenuId 在切頁瞬間的時序 race
      const currentPath = window.location.pathname;
      const flat: any[] = (menusState as any)?.routeflat || [];
      const matchedMenuId = flat.find((m: any) => m && m.path === currentPath)?.menuId;
      const menuIdForHeader = matchedMenuId != null ? matchedMenuId : tagsView.activeMenuId;
      config.headers['menuId'] = `${menuIdForHeader}`;
    }
    config.headers['system-lang'] = (`${window.localStorage.getItem('gs_lang') || baseReq.lang}`);
    // 打印每次请求的详细信息
    console.log('请求详情：');
    console.log('user', user);
    console.log('URL:', config.url);
    console.log('方法:', config.method);
    console.log('请求头:', config.headers);
    console.log('请求体:', config.data);
    console.log('请求体:', config.baseURL);

    console.log('请求 Cookie:', document.cookie); // 查看当前存储的 Cookie
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

//返回拦截处理
instance.interceptors.response.use(
  function (response) {
    // 打印响应的详细信息
    console.log('响应详情：');
    console.log('状态码:', response.status);
    console.log('URL:', response.config.url);
    console.log('响应头:', response.headers);
    console.log('响应数据:', response.data);
    if (response.data.rsCode === 'ssoError') {
      // 排除 get-logo-url 接口，不顯示錯誤訊息
      const url = response.config?.url || '';
      if (!url.includes('get-logo-url')) {
        const navigate = getGlobalNavigate();
        $message.error(response.data.rsMessages, 1);
        navigate('/account/login'); // 导航到登录页
      }
    }
    return response;
  },
  function (error) {
    // 判断错误是否是网络问题或者其他问题
    if (!error.response) {
      console.error('Error: Network or Server not reachable', error.message);
      console.log('错误请求:', error.config?.url || 'Unknown URL');
      console.log('错误信息:', error.message);
    } else if (error.response.status === 401) {
      // 处理 401 错误
      console.error('Error 401: Unauthorized access');
      console.log('错误请求:', error.response.config?.url || 'Unknown URL');
      console.log('错误响应数据:', error.response.data);
    } else {
      // 对其他错误进行处理
      console.log('错误请求:', error.response.config?.url || 'Unknown URL');
      console.log('错误响应数据:', error.response.data);
    }
    if (error.response?.status === 403) {
      // store.dispatch(navigate('/(outer)/login'))
      return;
    }

    $message.error('请求失败，请重新操作', 1);

    return Promise.reject(error);
  }
);

export const Http = {
  PostWrapQueryString: async (
    api: string,
    params?: any,
    queryString?: any,
    module: string = authServiceApp
  ): Promise<ApiResponse> => {
    api = `${mainApp}${module}${api}`;

    if (queryString) {
      const queryStringMap = Object.getOwnPropertyNames(queryString);
      api += '&';
      queryStringMap.forEach((item, index, array) => {
        if (queryString![item] !== '') {
          if (index > 0) {
            api += '&';
          }
          api += item + '=' + queryString![item];
        }
      });
    }

    return new Promise(async (resolve, reject) => {
      console.log(api);
      instance
        .post(api, params)
        .then(res => {
          resolve(res?.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  Post: async <T extends any = any>(
    api: string,
    params?: any,
    module: string = authServiceApp
  ): Promise<ApiResponse<T>> => {
    api = `${mainApp}${module}${api}`;
    return new Promise(async (resolve, reject) => {
      console.log(api);
      instance
        .post(api, params)
        .then(res => {
          resolve(res?.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  UploadFile: async (params?: any, onUploadProgress?: any): Promise<ApiResponse> => {
    let api = `${mainApp}/system/file/mgmt/upload`;

    return new Promise(async (resolve, reject) => {
      instance
        .post(api, params, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress
        })
        .then(res => {
          resolve(res?.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // CB7REQ-136 遊戲圖片固定路徑上傳：multipart 帶 gamePlatformCode/langSign/gameCode/imgName
  UploadGameImg: async (params?: any, onUploadProgress?: any): Promise<ApiResponse> => {
    let api = `${mainApp}/system/file/mgmt/upload-game-img`;

    return new Promise(async (resolve, reject) => {
      instance
        .post(api, params, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress
        })
        .then(res => {
          resolve(res?.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  UploadSmsExcel: async (params?: any, onUploadProgress?: any): Promise<ApiResponse> => {
    // 檢測是否為localhost環境
    // const isLocalhost = window.location.hostname === 'localhost' ||
    //                    window.location.hostname === '127.0.0.1' ||
    //                    window.location.hostname.startsWith('192.168.') ||
    //                    window.location.hostname.startsWith('10.') ||
    //                    window.location.hostname.includes('.local');
    //
    // const baseURL = isLocalhost ?
    //   `http://${window.location.hostname}:${window.location.port || '3000'}/` :
    //   (process.env.REACT_APP_API_BASE_URL || 'https://admin.darjawg.com/');

    let api = `${mainApp}/external/smsTask/mgmt/import-excel-data`;

    // 調試日誌
    console.log('SMS Excel上傳環境檢測:', {
      hostname: window.location.hostname,
      port: window.location.port,
      // isLocalhost: isLocalhost,
      baseURL: baseURL,
      finalAPI: api
    });

    return new Promise(async (resolve, reject) => {
      instance
        .post(api, params, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress
        })
        .then(res => {
          resolve(res?.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  /** 站内群发任务上传会员用户名文件：file + taskPkCode，接口 import-sms-member-excel-data */
  UploadSmsMemberExcel: async (params?: any, onUploadProgress?: any): Promise<ApiResponse> => {
    const api = `${mainApp}/external/smsTask/mgmt/import-sms-member-excel-data`;
    return new Promise((resolve, reject) => {
      instance
        .post(api, params, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress
        })
        .then(res => resolve(res?.data))
        .catch(reject);
    });
  },
  DownloadFile: async (api: string, params?: any) => {
    api = `${api}`;

    try {
      // 发送 GET 请求，设置 responseType 为 'blob'
      const response = await instance.get(api, {
        responseType: 'blob' // 确保返回的是文件流
      });

      // 创建下载链接
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');

      // 从 Content-Disposition 获取文件名（后端需返回此 Header）
      const contentDisposition = response.headers['content-disposition'];
      const fileName = contentDisposition
        ? decodeURIComponent(contentDisposition.split('filename*=')[1])
        : 'downloaded-file';

      link.href = url;
      link.setAttribute('download', fileName); // 设置文件名
      document.body.appendChild(link);
      link.click();

      // 清理链接
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('文件下载失败:', error);
    }
  },
  Get: async (api: string, params?: { [x: string]: string }, module: string = authServiceApp): Promise<ApiResponse> => {
    api = `${mainApp}${module}${api}`;

    params = { ...params};

    // if (params && params['lang']) {
    //   const lang = await localStorage.getItem('lang');
    //   params['system_lang'] = lang!;
    // }
    // params['system_lang'] = `${baseReq.lang}`;

    if (params) {
      const paramsMap = Object.getOwnPropertyNames(params);
      api += '?';
      paramsMap.forEach((item, index, array) => {
        if (params![item] !== '') {
          if (index > 0) {
            api += '&';
          }
          api += item + '=' + params![item];
        }
      });
    }

    return new Promise((resolve, reject) => {
      instance
        .get(api)
        .then(res => {
          resolve(res?.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  FormPost: async (api: string, params: { [key: string]: any }, module: string = authServiceApp,contentType: string = 'application/x-www-form-urlencoded'): Promise<ApiResponse> => {
    // 使用 URLSearchParams 构建表单数据
    const formBody = new URLSearchParams();
    params = { ...params };
    api = `${mainApp}${module}${api}`;
    // api = `${api}?lang=${baseReq.lang}&version=${baseReq.version}`;
    Object.keys(params).forEach(key => {
      const value = params[key];
      formBody.append(key, value);
    });

    // if (formBody.get('lang')) {
    //   const lang = await localStorage.getItem('lang');
    //   formBody.set('lang', lang!);
    // }

    return new Promise((resolve, reject) => {
      instance
        .post(api, formBody.toString(), {
          headers: {
            'Content-Type': contentType
          }
        })
        .then(res => {
          resolve(res?.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  /** 通过统一 axios 实例上传 FormData（自动携带认证 Header） */
  UploadFormData: async (
    api: string,
    formData: FormData,
    module: string = authServiceApp
  ): Promise<ApiResponse> => {
    const fullApi = `${mainApp}${module}${api}`;
    return new Promise((resolve, reject) => {
      instance
        .post(fullApi, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(res => resolve(res?.data))
        .catch(reject);
    });
  },
  /** 通过统一 axios 实例下载 Blob 文件（POST 请求，自动携带认证 Header，触发浏览器下载） */
  DownloadBlob: async (
    api: string,
    params?: Record<string, unknown>,
    module: string = authServiceApp,
    defaultFileName: string = 'download'
  ): Promise<void> => {
    const fullApi = `${mainApp}${module}${api}`;
    return new Promise((resolve, reject) => {
      instance
        .post(fullApi, params, { responseType: 'blob' })
        .then(response => {
          const contentDisposition = response.headers['content-disposition'];
          let fileName = defaultFileName;
          if (contentDisposition && contentDisposition.includes("filename*=")) {
            try {
              const parsed = contentDisposition.split("filename*=UTF-8''")[1];
              if (parsed) fileName = decodeURIComponent(parsed);
            } catch {
              fileName = defaultFileName;
            }
          }
          fileName = fileName.replace(/[/\\:*?"<>|]/g, '_');

          const url = window.URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);
          link.click();
          window.URL.revokeObjectURL(url);
          resolve();
        })
        .catch(reject);
    });
  },
  changeBaseUrl: (url: string) => {
    instance.defaults.baseURL = url;
    console.log(`Base URL changed to: ${url}`);
  },
  url: () => instance.defaults.baseURL
};
